import React, { ReactNode, useState } from "react";
import kingspan from "../../assets/kingspan_logo_blue.svg";
import { useAuth } from "../../authContext";
import { Button } from "@/components/ui/button";

interface ProtectedRouteProps {
    children: ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
    const { account, login } = useAuth(); // Use MSAL context for account and login functions
    const [showError, setShowError] = useState(false);

    // If the user is not authenticated, show a login screen or spinner
    if (!account) {
        return (
            <div className={"flex h-screen flex-col items-center justify-center gap-4"}>
                <img src={kingspan} className={"h-auto w-[200px]"} alt="Kingspan logo" />
                <div className={"mx-auto max-w-[500px] px-2 text-center text-gray-600"}>
                    <p>Welcome to InsuBot</p>
                </div>

                <Button onClick={() => login().catch(() => setShowError(true))}>Login</Button>
                {showError && (
                    <div className={"max-w-[500px] text-center text-red-600"}>
                        <p>Authentication failed. Please try again.</p>
                    </div>
                )}
            </div>
        );
    }

    // If authenticated, render the child components
    return <>{children}</>;
};

export default ProtectedRoute;
